import { IconProps } from 'ui/icons/types'

export enum CardType {
  PROFILE = 'profileStatus',
  LOCATION = 'locationsStatus',
  CARS = 'carsStatus',
  PRICE_LIST = 'priceListsStatus',
  TERMS = 'termsConditionsStatus',
  DOCUMENTS = 'documentsStatus',
}

export type CardOption = {
  type: CardType
  Icon: React.ComponentType<IconProps>
  title: string
  description: string
  path: string
}
